import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

const BlueProductTechnologyIcon = ({
  width = 16,
  height = 13,
  ...props
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 13"
      fill="none"
      {...props}
    >
      <path
        d="M11.8408 0C6.56393 0 0 5.2574 0 9.61465C0 11.865 1.79509 13 4.16596 13C5.90686 13 8.01355 12.3869 10.0457 11.2062V2.51129C9.50381 3.40491 6.95682 7.00552 4.91109 8.92323C3.86791 9.90165 3.04149 10.3256 2.33023 10.3256C1.53091 10.3256 1.15157 9.80381 1.15157 9.0276C1.15157 5.50527 7.30906 0.926242 11.387 0.926242C13.0669 0.926242 14.1507 1.64375 14.1507 3.03964C14.1507 4.31811 13.2498 5.92273 11.7121 7.40341V10.0973C14.3946 8.05569 16 5.45308 16 3.35273C16 1.14149 14.2117 0 11.8408 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BlueProductTechnologyIcon
